import { Container as ContainerUI } from '@components/design-system';
import { styled } from '@styles/stitches';

export const Container = styled('header', {
  position: 'sticky',
  top: 0,
  width: '100%',
  backgroundColor: '$primaryBackground',
  color: '$primaryFill',
  zIndex: 2,

  [`& ${ContainerUI}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // height: '$space$1',
  },
});

export const Auth = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  '& > *': {
    marginLeft: '$space$3',
  },
});

export const Mobile = styled('div', {
  display: 'flex',

  '@bp1': {
    display: 'none',
  },
});

export const Desktop = styled('div', {
  display: 'none',

  '@bp1': {
    display: 'flex',
  },
});
